import { trackLeaderEvent } from "@/lib/leaderEventLogger";
import { trackCoachEvent } from "@/lib/coachEventLogger";

export type BehavioralObservationTelemetrySurface = "post_meeting" | "insights" | "today" | "moments" | "messaging";
export type CoachBehavioralObservationTelemetrySurface = "coach_post_meeting" | "coach_session_prep";

type TrackBehavioralObservationViewedParams = {
  leaderId: string;
  surface: BehavioralObservationTelemetrySurface;
  fallbackUsed: boolean;
  behaviorName: string | null;
  hasPatternLine: boolean;
  hasReflectionLine: boolean;
  transcriptId?: string | null;
  meetingId?: string | null;
};

type TrackCoachBehavioralObservationViewedParams = {
  coachId: string;
  leaderId: string;
  surface: CoachBehavioralObservationTelemetrySurface;
  fallbackUsed: boolean;
  behaviorName: string | null;
  hasPatternLine: boolean;
  hasReflectionLine: boolean;
  transcriptId?: string | null;
  meetingId?: string | null;
};

function buildObservationTelemetryProperties(params: {
  surface: string;
  fallbackUsed: boolean;
  behaviorName: string | null;
  hasPatternLine: boolean;
  hasReflectionLine: boolean;
  transcriptId?: string | null;
  meetingId?: string | null;
}): Record<string, string | boolean> {
  const properties: Record<string, string | boolean> = {
    surface: params.surface,
    fallback_used: params.fallbackUsed,
    has_pattern_line: params.hasPatternLine,
    has_reflection_line: params.hasReflectionLine,
  };

  if (params.behaviorName?.trim()) {
    properties.behavior_name = params.behaviorName.trim();
  }
  if (params.transcriptId?.trim()) {
    properties.transcript_id = params.transcriptId.trim();
  }
  if (params.meetingId?.trim()) {
    properties.meeting_id = params.meetingId.trim();
  }

  return properties;
}

export async function trackBehavioralObservationViewed(
  params: TrackBehavioralObservationViewedParams,
): Promise<void> {
  const properties = buildObservationTelemetryProperties(params);

  await trackLeaderEvent({
    leaderId: params.leaderId,
    eventName: "leader_behavioral_observation_viewed",
    properties,
  });
}

export async function trackCoachBehavioralObservationViewed(
  params: TrackCoachBehavioralObservationViewedParams,
): Promise<void> {
  const properties = buildObservationTelemetryProperties(params);

  await trackCoachEvent({
    coachId: params.coachId,
    leaderId: params.leaderId,
    eventName: "coach_behavioral_observation_viewed",
    properties,
  });
}
